<template>
	<div class="lp-data-importer mt-2">
		<div class="form-group col-6">
			<label for="file">Choose CSV file to import</label>
			<input class="form-control" type="file" @change="uploadCsvFile($event)" />
			<div v-if="loading">Uploading file</div>
		</div>
		<div class="row">
			<h4>
				{{ tableName }}
				<div v-if="loading" class="spinner-border spinner-border-sm" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</h4>
			<template v-for="(column, index) in tableColumns">
				<div :key="index" class="row">
					<div class="form-group mb-2 col-6">
						<input
							type="text"
							readonly
							:value="column.name + ' [' + column.type + ']'"
							class="form-control"
						/>
					</div>
					<div v-if="csvColumns.length > 0" class="form-group mb-2 col-6">
						<select v-model="column.value" class="form-select">
							<option value="">Select data</option>
							<template v-for="(csv, index) in csvColumns">
								<option :key="index" :value="csv">{{ csv }}</option>
							</template>
						</select>
					</div>
				</div>
			</template>
			<div class="col-12">
				<button v-if="!loading" class="btn btn-primary float-end" @click="insertDataFromCSV()">
					Import data
				</button>
				<button v-else class="btn btn-primary float-end" type="button" disabled>
					<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
					Loading...
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { handleErrors } from '../../actions/helpers'
import restApi from '../../api'
export default {
	name: 'LPDataImporter',
	props: ['tableName'],
	data() {
		return {
			csvColumns: [],
			tableColumns: [],
			loading: false,
			path: '',
		}
	},
	mounted() {
		this.getTableColumns()
	},
	methods: {
		// Upload CSV file
		uploadCsvFile($event) {
			this.loading = true
			var form = new FormData()
			form.append('file', $event.target.files[0])
			form.append('name', this.tableName)

			const config = {
				headers: { 'content-type': 'multipart/form-data' },
			}
			restApi
				.post('/helper/upload-csv-file', form, config)
				.then(({ data }) => {
					this.csvColumns = data.headers
					this.path = data.path
					this.loading = false
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Insert data from CSV
		insertDataFromCSV() {
			this.loading = true
			let data = {
				tableName: this.tableName,
				tableColumnsMap: this.tableColumns,
				csvPath: this.path,
			}
			restApi
				.post('/helper/insert-data-csv', data)
				.then(({ data }) => {
					this.loading = false
					console.info(data)
					this.$swal.fire({
						icon: 'success',
						title: 'Data imported successfully!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.loading = false
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		// Get table Columns
		getTableColumns() {
			restApi
				.post('/helper/table-columns', { table: this.tableName })
				.then(({ data }) => {
					this.tableColumns = data
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
	},
}
</script>
